import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { changeSidebarVisibility } from '../redux/actions/sidebarActions';

class MainWrapper extends PureComponent {

  changeSidebarVisibility = () => {
    this.props.dispatch(changeSidebarVisibility());
  };

  render () {
    const theme = this.props.theme.className
    return (
      <div className={theme}>
        {/* <div
          id="overlay"
          className={this.props.sidebar.collapse ? 'off' : 'on'}
          onClick={this.changeSidebarVisibility}></div> */}
          <div className={this.props.sidebar.collapse ? 'wrapper wrapper--full-width' : 'wrapper sidebar-open'}>
            {this.props.children}
          </div>
      </div>
    )
  }
}

export default connect(state => {
  return {
    theme: state.theme,
    sidebar: state.sidebar
  }
})(MainWrapper)



// WEBPACK FOOTER //
// ./src/app/MainWrapper.js